import React from "react";
import { useInView } from "react-intersection-observer";
const Tokenomics = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Only trigger once when the element comes into view
  });
  return (
    <>
      <section
        id="tokenomics"
        ref={ref}
        className={`Tokenomics ${inView ? "showcontent" : ""}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="content">
                <div className="left-content">
                  <div className="txt">
                    <h4>Allocation</h4>
                    <p>
                      100 billion ZForge Tokens, strategically allocated for
                      development, community rewards, staking incentives, and
                      ecosystem expansion, ensuring sustainable growth and a
                      thriving gaming economy.
                    </p>
                  </div>
                  <ul className="list-inline">
                    <li className="advisory">
                      <div>
                        <h3>Staking</h3>
                        <label>30%</label>
                      </div>
                      <div>
                        <h4>30B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>
                    <li className="fund">
                      <div>
                        <h3>Pre Sale</h3>
                        <label>20%</label>
                      </div>
                      <div>
                        <h4>20B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>

                    <li className="growth">
                      <div>
                        <h3>Public Sale</h3>
                        <label>20%</label>
                      </div>
                      <div>
                        <h4>20B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>

                    <li className="ecommerce">
                      <div>
                        <h3>Team</h3>
                        <label>15%</label>
                      </div>
                      <div>
                        <h4>15B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>

                    <li className="transparency">
                      <div>
                        <h3>Eco-System Fund & Liquidity:</h3>
                        <label>10%</label>
                      </div>
                      <div>
                        <h4>10B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>
                    <li className="partnership">
                      <div>
                        <h3>Rewards & Incentives</h3>
                        <label>5%</label>
                      </div>
                      <div>
                        <h4>5B ZFORGE</h4>
                        {/* <h5>Raised</h5> */}
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="right-content">
                  <div className="circle-content">
                    <img src="/images/graphcircle.png" alt="" />

                    <div className="sale">
                      <span>5%</span>
                      Rewards & Incentives
                    </div>

                    <div className="growth">
                      <span>10%</span>
                      Eco-System Fund & Liquidity
                    </div>
                    <div className="public">
                      <span>30%</span>
                      Staking
                    </div>
                    <div className="advisory">
                      <span>15%</span>
                      Team
                    </div>

                    <div className="partner">
                      <span>20%</span>
                      Pre-Sale
                    </div>
                    <div className="growth future">
                      <span>20%</span>
                      Public Sale
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container" id="roadmap">
          <div className="row">
            <div className="col-12">
              <div className="Roadmap">
                <div className="image">
                  <img src="./images/roadmapback.png" alt="" />
                </div>
                <div className="roadmap-content">
                  <div className="heading">
                    <h4>Roadmap</h4>
                    <p>
                      Our journey is mapped for success! Explore how Zeuss Token
                      evolves from development to ecosystem expansion, building
                      a decentralized future that reshapes communication,
                      commerce, and finance. Each phase is a step closer to
                      innovation and legacy creation.
                    </p>
                  </div>
                  <ul className="timeline list-inline">
                    <li
                      className="q1"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 1</h4>
                      <h5>Development and Testing:</h5>
                      <p>
                        Develop the core functionalities of the platform and
                        conduct rigorous testing.
                      </p>
                    </li>
                    <li
                      className="q2"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 2</h4>
                      <h5>Public Launch:</h5>
                      <p>Launch the public beta version of the platform.</p>
                    </li>
                    <li
                      className="q3"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 3:</h4>
                      <h5>Mainnet Launch:</h5>
                      <p>Deploy the mainnet and fully launch the platform.</p>
                    </li>
                    <li
                      className="q4"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 4:</h4>
                      <h5>Ecosystem Expansion:</h5>
                      <p>
                        Expand the ecosystem by partnering with other projects
                        and businesses.
                      </p>
                    </li>
                    <li
                      className="q5"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 5:</h4>
                      <h5>Ecosystem Expansion:</h5>
                      <p>
                        Expand the ecosystem by partnering with other projects
                        and businesses.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div className="container" id="roadmap">
          <div className="row">
            <div className="col-12">
              <div className="Roadmap">
                <div className="image">
                  <img src="./images/roadmapback.png" alt="" />
                </div>
                <div className="roadmap-content">
                  <div className="heading">
                    <h4>Roadmap</h4>
                    <p>
                      Our journey is mapped for success! Explore how Zeuss Token
                      evolves from development to ecosystem expansion, building
                      a decentralized future that reshapes communication,
                      commerce, and finance. Each phase is a step closer to
                      innovation and legacy creation.
                    </p>
                  </div>
                  <ul className="timeline list-inline">
                    <li
                      className="q1"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 1</h4>
                      <h5>Development and Testing:</h5>
                      <p>
                        Develop the core functionalities of the platform and
                        conduct rigorous testing.
                      </p>
                    </li>
                    <li
                      className="q2"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 2</h4>
                      <h5>Pre-sale:</h5>
                      <p>Community Pre-Sale</p>
                    </li>
                    <li
                      className="q3"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 3:</h4>
                      <h5>Public Launch</h5>
                      <p>Launch the public beta version of the planform.</p>
                    </li>
                    <li
                      className="q4"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 4:</h4>
                      <h5>Mainnet Launch</h5>
                      <p>Deploy the mainnet and fully launch the platform.</p>
                    </li>
                    <li
                      className="q5"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 5:</h4>
                      <h5>Ecosystem Expansion</h5>
                      <p>
                        Expand the ecosystem by partnering with other projects
                        and businesses.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default Tokenomics;
